// extracted by mini-css-extract-plugin
module.exports = {"messenger":"Messenger_messenger__1tXXf"};